import { createSelector } from 'reselect';

import * as userSelectors from 'common.components/user/selectors';

export const getHasJoinedBeforeNewLessonModalRelease = createSelector(
    [userSelectors.getDateJoined],
    (dateJoined: Date): boolean => {
        const newModalReleaseDate = new Date('2020-08-13');

        return dateJoined <= newModalReleaseDate;
    }
);
